import {ChevronRight} from '@mui/icons-material'
import {Box} from '@mui/material'

import {CARD_CHEVRON_CLASS} from './CardLinkWrapper'

export const CardLinkChevron = () => (
  <Box className={CARD_CHEVRON_CLASS}>
    <ChevronRight />
  </Box>
)
